export default {
  search: {
    title: 'Choose your destination',
    departureDate: 'Departure',
    returnDate: 'Return',
    continue: 'Continue',
  },
  travelPlanner: {
    search: {
      origin: 'From',
      destination: 'To',
      switchDirection: 'Switch direction',
    },
  },
}
